import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
export const PhoneButton = ({ buttonInfo, variant, appContext, phoneWithNumber, trackButtonClick, isMobileScreenSize, isLoading, }) => {
    var _a;
    const { label, target, url, type } = buttonInfo;
    const phoneNumber = `tel:${url.replace(/\s/g, '')}`;
    let phoneButtonLabel = label;
    if (buttonInfo.type === 'phone' && appContext === 'tiles' && phoneWithNumber) {
        phoneButtonLabel = `${(_a = buttonInfo.label) !== null && _a !== void 0 ? _a : ''} ${url}`;
    }
    return (React.createElement(TextButton, { variant: variant, href: phoneNumber, target: target, "data-testid": `${type}-button-variant-${variant}`, onClick: () => {
            trackButtonClick(buttonInfo, variant);
        }, isFullWidth: isMobileScreenSize, isLoading: isLoading, size: dynamicStylingHelper('md', 'sm') }, phoneButtonLabel));
};
